/**
 * Scripts to execute after the size chart modal is shown.
 */

if (!window.__sizeChartMediaInit) {
  window.__sizeChartMediaInit = true;

  document.addEventListener('modal:handleAfterShow', (event) => {
    const modal = event.target;
    if (!modal?.id?.startsWith('SizeChartModal-')) return;

    // Reset the video to the beginning when the modal is shown
    window.setTimeout(() => {
      modal.querySelectorAll('video-element[autoplay]').forEach((videoElement) => {
        const video = videoElement.querySelector('video');
        if (video) {
          video.currentTime = 0;
          video.play().catch(() => { });
          return;
        }
        videoElement.play();
      });
    }, 100);
  });
}
